// ** React Imports
import { Fragment, useContext } from "react"

// ** Custom Components
import NavbarUser from "./NavbarUser"
import YearDropDown from './YearDropDown'
// import NotificationDropdown from "./NotificationDropdown"
import { MuiNotification } from '@student_components/MuiNotification'

import LanguageDropdown from "./LanguageDropdown"
// ** Third Party Components
import { Sun, Moon, Menu } from "react-feather"

import { AuthContext } from '@context/AuthContext'

// ** Reactstrap Imports
import useApi from '@hooks/useApi';
import { NavItem, NavLink } from "reactstrap"

// import { useTheme } from '@mui/material'

const ThemeNavbar = (props) => {
    const { isAdmissionUser, userDetail } = useContext(AuthContext)

    // ** Props
    const { skin, setSkin, setMenuVisibility } = props

    // ** Function to toggle Theme (Light/Dark)
    const ThemeToggler = () => {
        if (skin === "dark") {
            return <Sun className="ficon" onClick={() => setSkin("light")} />
        } else {
            return <Moon className="ficon" onClick={() => setSkin("dark")} />
        }
    }

    const { instance } = useApi()

    // const theme = useTheme()

    return (
        <Fragment>
                <div className="bookmark-wrapper d-flex align-items-center me-1">
                    <ul className="navbar-nav d-xl-none">
                        <NavItem className="mobile-menu me-auto">
                            <NavLink
                                className="nav-menu-main menu-toggle hidden-xs is-active"
                                onClick={() => setMenuVisibility(true)}
                            >
                                <Menu className="ficon" />
                            </NavLink>
                        </NavItem>
                    </ul>
                    <NavItem className="d-block">
                        <NavLink className="nav-link-style">
                            <ThemeToggler />
                        </NavLink>
                    </NavItem>
                    <ul className="nav d-none d-sm-block align-items-center">
                        <YearDropDown />
                    </ul>
                </div>
                <ul className="nav flex-wrap navbar-nav d-flex justify-content-end align-items-center">
                    <div className="">
                        <LanguageDropdown/>
                    </div>
                    {
                        !isAdmissionUser && userDetail?.student?.school
                        ?
                            <MuiNotification
                                instance={instance}
                                // theme={theme}
                            />
                        :
                            null
                    }
                    <NavbarUser skin={skin} setSkin={setSkin} />
                </ul>

        </Fragment>
    )
}

export default ThemeNavbar
